<ng-container *ngIf="contractType === DriverContractType.ShortTerm" i18n
  >Short term</ng-container
>
<ng-container *ngIf="contractType === DriverContractType.LongTerm" i18n
  >Long term</ng-container
>
